import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { GoogleLogo, Notebook } from "@phosphor-icons/react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [loading, user, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen max-w-md mx-auto flex flex-col justify-between px-6 py-12 bg-background">
      <div className="pt-16">
        <div className="h-14 w-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-8">
          <Notebook size={28} weight="duotone" />
        </div>
        <h1 className="text-4xl font-heading font-bold tracking-tight leading-tight">
          Family<span className="text-transfer">Ledger</span>
        </h1>
        <p className="mt-4 text-base text-muted-foreground leading-relaxed">
          A calm, shared ledger for your household. Track income, expenses, credit cards and businesses — together, in your home currency.
        </p>
        <ul className="mt-8 space-y-3 text-sm text-secondary-foreground">
          <li className="flex gap-2"><span className="text-income">●</span> Two members, one household ledger</li>
          <li className="flex gap-2"><span className="text-expense">●</span> Credit-card spends without double counting</li>
          <li className="flex gap-2"><span className="text-transfer">●</span> Reports & CSV export any time</li>
        </ul>
      </div>
      <div className="pb-6">
        <button
          data-testid="google-login-btn"
          onClick={signIn}
          className="w-full h-14 rounded-2xl bg-primary text-primary-foreground font-medium flex items-center justify-center gap-3 active:scale-[0.98] transition-transform"
        >
          <GoogleLogo size={22} weight="bold" />
          Continue with Google
        </button>
        <p className="mt-4 text-center text-xs text-muted-foreground">Private · For your household only</p>
      </div>
    </div>
  );
}
